import React from 'react';
import styles from './uploadProgressBar.module.css';

const formatBytes = (bytes) => {
  if (bytes === 0) return '0 Б';
  const k = 1024;
  const sizes = ['Б', 'КБ', 'МБ', 'ГБ'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
};

const UploadProgressBar = ({ progress, fileName, queue }) => {
  if (!progress) return null;

  const { loaded, total, percent } = progress;
  const showQueue = queue && queue.total > 1;

  return (
    <div className={styles.overlay}>
      <div className={styles.content}>
        <div className={styles.spinner}>
          <span></span>
        </div>
        
        <div className={styles.progressContainer}>
          {showQueue && (
            <div className={styles.queueInfo}>
              Файл {queue.current} из {queue.total}
            </div>
          )}
          
          <div className={styles.fileName}>{fileName}</div>
          
          <div className={styles.track}>
            <div 
              className={styles.fill} 
              style={{ width: `${percent}%` }}
            />
          </div>
          
          <div className={styles.stats}>
            {formatBytes(loaded)} / {formatBytes(total)}
          </div>
          
          <div className={styles.percent}>{percent}%</div>
          
          {percent < 100 && (
            <p className={styles.status}>Загрузка документа...</p>
          )}
          {percent === 100 && (
            <p className={styles.statusDone}>Обработка файла...</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default UploadProgressBar;

